export default __webpack_public_path__ + "static/media/426.2c777010.png";